import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee, Introduction } from "@/components/site/Introduction";
import { About } from "@/components/site/About";
import { WhoFor, WhatOffers } from "@/components/site/WhoFor";
import { HowItWorks, Offer } from "@/components/site/Process";
import { FAQ } from "@/components/site/FAQ";
import { FinalCTA, Footer } from "@/components/site/FinalCTA";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const noLenis = new URLSearchParams(window.location.search).has("nolenis");

    let lenis;
    let raf;
    if (!reduce && !noLenis) {
      lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
      });
      const loop = (time) => {
        lenis.raf(time);
        raf = requestAnimationFrame(loop);
      };
      raf = requestAnimationFrame(loop);
    }

    const onClick = (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;
      const id = link.getAttribute("href");
      if (!id || id === "#") return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 72;
      if (lenis) lenis.scrollTo(top, { duration: 1.3 });
      else window.scrollTo({ top, behavior: "smooth" });
    };
    document.addEventListener("click", onClick);

    const scrollToHash = () => {
      const id = window.location.hash;
      if (!id || id === "#") return;
      const target = document.querySelector(id);
      if (!target) return;
      const top = target.getBoundingClientRect().top + window.scrollY - 72;
      if (lenis) lenis.scrollTo(top, { immediate: true });
      else window.scrollTo({ top });
    };
    const hashTimer = setTimeout(scrollToHash, 350);

    return () => {
      clearTimeout(hashTimer);
      document.removeEventListener("click", onClick);
      if (raf) cancelAnimationFrame(raf);
      if (lenis) lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain min-h-screen bg-ivory">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Introduction />
        <About />
        <WhoFor />
        <WhatOffers />
        <HowItWorks />
        <Offer />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
